/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import { getBillingDetailsV2 } from '@modules/billing-api/v1/callers'
import type { operations } from '@modules/billing-api/v1/types'
import type { QueryHook, QueryHookOptions } from '@modules/query/types'
import { queryClient } from '@modules/query'

import { defaultBillingOptions } from './constants'

const GET_BILLING_DETAILS_QUERY_KEY = 'getBillingDetailsV1'

const useGetBillingDetails: QueryHook<typeof getBillingDetailsV2> = (
  args: {
    pathParameters: operations['getBillingDetailsV2']['parameters']['path']
  },
  options?: QueryHookOptions,
) =>
  useQuery(
    [GET_BILLING_DETAILS_QUERY_KEY, args.pathParameters.organization_id],
    () => getBillingDetailsV2(args),
    {
      ...defaultBillingOptions,
      ...options,
    },
  )

export const invalidateGetBillingDetails = () =>
  queryClient.invalidateQueries({ queryKey: [GET_BILLING_DETAILS_QUERY_KEY] })

export default useGetBillingDetails
